var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticleShortcut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "article_shortcut"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_590_38210",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_590_38210)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "article_shortcut_2",
    d: "M7.5 14H12V12.5H7.5V14ZM7.5 10.75H14V9.25H7.5V10.75ZM6 7.5H14V6H6V7.5ZM4.97917 18C3.86806 18 2.92708 17.6146 2.15625 16.8438C1.38542 16.0729 1 15.1319 1 14.0208C1 13.2569 1.19444 12.5625 1.58333 11.9375C1.97222 11.3125 2.47917 10.8333 3.10417 10.5H1V9H6V14H4.5V11.5417C3.91667 11.6528 3.4375 11.9375 3.0625 12.3958C2.6875 12.8542 2.5 13.3889 2.5 14C2.5 14.6969 2.73958 15.2878 3.21875 15.7727C3.69792 16.2576 4.28472 16.5 4.97917 16.5V18ZM7.5 17V15.5H15.5V4.5H4.5V7.5H3V4.49479C3 4.0816 3.14687 3.72917 3.44062 3.4375C3.73438 3.14583 4.0875 3 4.5 3H15.5C15.9125 3 16.2656 3.14688 16.5594 3.44063C16.8531 3.73438 17 4.0875 17 4.5V15.5C17 15.9125 16.8531 16.2656 16.5594 16.5594C16.2656 16.8531 15.9125 17 15.5 17H7.5Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleShortcut);
export default __webpack_public_path__ + "static/media/article_shortcut.16cb9a07b1394e4e4e4bef289c47d1a3.svg";
export { ForwardRef as ReactComponent };